<template>
  <div class="my_feedback">
    <div class="edit_supply_warp">
      <van-field
        class="edit_supply_textarea"
        v-model="content"
        type="textarea"
        placeholder="Please add your suggestions or feedback"
        @input="fieldChange"
        maxlength="500"
        rows="4"
        show-word-limit 
      />
      <div class="uploading_wrap">
       
        <van-uploader
          v-model="fileList"
          multiple
          :max-count="5"
          :before-read="beforeRead"
          :after-read="afterRead"
          @delete="deleteimg"
          :preview-size="size"
        >
        </van-uploader>
      </div>
      <span style="color:#bfbfbf;">5 pictures at most</span>
      <div class="btn-bg">
        <div class="btn" @click="submitRelease">
          <span>Submit</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name: "my-feedback",
  components: {},
  data() {
    return {
      content: "",
      isNotPreview: false,
      isMy: false,
      fileList: [],
      Upimg: [], // 上传的图片
      size: "2.14rem",
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
      exhibitionInfo:"getExhibitionInfo"
    }),
  },
  created() {},
  methods: {
    ...mapActions({
      submitFeedBack:'my/submitFeedBack'
    }),
    fieldChange(e) {
      this.content = e; 
    },
    // 反馈
    async submitRelease() {
      if (!this.content) {
        this.$toast.fail("Please add your suggestions or feedback");
        return;
      }
      // if (/.*1[3|4|5|7|8][0-9]{9}.*/.test(this.content)) {
      //   this.$toast.fail("不能包含手机号");
      //   return;
      // }
      this.$toast.loading({
        message: 'loading...',
        forbidClick: true,
      })
      let imgUrls=[];
      
      if (this.Upimg) {
        this.Upimg.map((el) => {
          imgUrls.push(el.url);
        });
      }
      console.log(this.exhibitionInfo,this.userInfo);
      let opt={
        exhibitionId:this.exhibitionId,
        origin:this.exhibitionInfo.exhibition.name,
        userId:this.userInfo.userId,
        memberId:this.userInfo.inMember.memberId,
        content:this.content,
        images:imgUrls.join(';'),
        avatarUrl:this.userInfo.avatarUrl,
      }
      if(this.userInfo.name){
        opt.fullName=this.userInfo.name
      }
      if(this.userInfo.company){
        opt.companyName=this.userInfo.company
      }
      if(this.userInfo.jobTitle){
        opt.jobTItle=this.userInfo.jobTitle
      }
      if(this.userInfo.phone){
        opt.phoneNumber=this.userInfo.phone
      }
      if(this.userInfo.title){
        opt.title=this.userInfo.title;
      }
      let res= await this.submitFeedBack(opt);
      if(res.result){
        this.$toast.success({
          message:"Success",
          forbidClick:true,
        });  
        setTimeout(() => {
          this.$router.go(-1);
        }, 500);
      }else{
        this.$toast.fail("Failed to submit");
      }
    },

    viewImg(e) {
      this.isNotPreview = true;
      let imgL = this.imgList;
      imgL = imgL.map((c) => {
        return (c += this.oPotoView);
      });
    },
    deleteimg(index) {
      if (index.url) {
        this.Upimg = this.fileList;
      }
    },

    // 返回布尔值
    beforeRead(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJPG) {
        this.$toast.fail("The picture format is not correct");
        return false;
      }

      if (file.size > 1024 * 4000) {
        //图片不能超过4M
        this.$toast.fail("Please upload pictures within 4 megabytes");
        return false;
      }

      return true;
    },
    // 上传完成，上传至服务器
    afterRead(file) {
      this.$toast.loading({
        message: "Uploading...",
        forbidClick: true,
        duration: 0,
      });
      let data = new FormData();
      data.append("multfile", file.file);
      data.append("operaType", null);
      // this.$dialog.loading.open();
      this.$http
        .post("https://online-api.zhanshangxiu.com/api/v1/file", data)
        .then((res) => {
          // this.Upimg.push(res.data.Data.imgUrls[0])
          if (res.data.data) {
            this.fileList = [];
            let opt = {
              url: res.data.data[0],
            };
            this.Upimg.push(opt);
            this.Upimg.map((el) => {
              this.fileList.push(el);
            });
            this.show = false;
            this.$toast.clear();
          }
        })
        .catch((err) => {
          this.$toast.fail("failed to upload！");
          this.$toast.clear();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.my_feedback {
  width: 100%;
  background-color: #f5f5f5;
  min-height: 100vh;
}
.edit_supply_warp {
  padding: 0 0.24rem 0.24rem;
  color: #fff;
  background: #fff;
  .van-cell {
    padding: 0.25rem 0.2rem 0.1rem;
    margin-bottom: 0.5rem;
    border-radius: 3px;
    background: #fff;
    overflow-y: initial;
    &::after {
      display: none;
    }
    .van-field__input {
      min-height: 1.3rem;
      color: #333;
    }
    .van-field__word-limit {
      color: #bfbfbf;
    }
    // &::v-deep .van-cell__value{
    //   .van-field__control{
    //     line-height: 0.28rem;
    //     color: #fff;
    //     word-break:break-all;
    //     word-wrap:break-word;
    //     text-align: justify;
    //   }
    // }
  }
  .uploading_wrap {
    display: flex;
    margin-bottom: 0.2rem;
    flex-wrap: wrap;

    .img_block {
      margin-right: 0.2rem;
      position: relative;
      &:nth-child(3) {
        margin-right: 0;
      }
      .img_wrap {
        width: 2.14rem;
        height: 2.14rem;
        border-radius: 1px;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          // object-fit: cover;
        }
      }
      .van-icon {
        background: transparent;
        font-size: 0.35rem;
        top: -0.12rem;
        right: -0.12rem;
        color: #fff;
      }
    }
    .img_uploading {
      .van-uploader__upload-icon {
        font-size: 0.3rem;
      }
      .van-image__img {
        width: 2.14rem;
        height: 2.14rem;
      }
      margin: 0;
      border: 1px #cccccc dashed;
      display: flex;
      justify-content: center;
      width: 2.14rem;
      height: 2.14rem;
      background-color: #f2f2f2;
      border-radius: 0.1rem;
    }
    .van-icon-clear {
      font-size: 0.3rem;
      position: absolute;
      top: 0;
      right: 0;
      font-size: 0.3rem;
      margin-right: -0.15rem;
      margin-top: -0.15rem;
      color: #666;
    }
  }
}
.select-topic {
  height: 0.88rem;
  width: 100%;
  margin-top: 0.3rem;
  background-color: #fff;
  span {
    line-height: 0.88rem;
    font-size: 0.3rem;
  }
  &-box {
    padding: 0 0.3rem;
    display: flex;
    position: relative;
    align-items: center;
    .span1 {
      color: #ff5c00;
      font-weight: bold;
      display: inline-block;
      margin-right: 0.2rem;
    }
  }
  &-list {
    padding: 0 0.3rem;
    display: flex;
    position: relative;
    align-items: center;
    .lspan {
      color: #ff5c00;
      font-weight: bold;
      display: inline-block;
      margin-right: 0.2rem;
    }
  }
}
.topic-tips {
  margin-right: 0.2rem;
  height: 0.48rem;
  display: flex;
  align-items: center;
  border-radius: 0.24rem;
  background-color: #ffddcc;
  .span-tips-1 {
    padding: 0.14rem 0.2rem;
    font-size: 0.22rem;
    color: #ff5500;
  }
  .span-tips-2 {
    color: #ff5500;
    font-size: 0.22rem;
    margin-left: 0.1rem;
  }
}
.scroll_view {
  overflow: auto;
  white-space: nowrap;
  width: 6rem;
  position: relative;
}
.trans {
  position: absolute;
  width: 0.6rem;
  height: 0.88rem;
  right: 0.7rem;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1)
  );
}
.btn-bg {
  position: fixed;
  background-color: #fff;
  bottom: 0;
  left: 0;
  right: 0;
  height: 0.98rem;
  width: 100%;
  text-align: center;
}
.btn {
  width: 6.5rem;
  height: 0.78rem;
  background-color: #1890ff;
  border-radius: 0.37rem;
  border: solid 2px #1890ff;
  margin: 0 auto;
  margin-top: 0.1rem;
  span {
    color: #fff;
    font-size: 0.3rem;
    line-height: 0.78rem;
  }
}
</style>
